import { useEffect } from 'react';

const ensureMetaTag = (attr, key, content) => {
  if (!content) return;
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

const setCanonical = (href) => {
  if (!href) return;
  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', href);
};

const setJsonLd = (schema) => {
  if (!schema) return;
  const existing = document.getElementById('page-json-ld');
  if (existing) {
    existing.remove();
  }

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = 'page-json-ld';
  script.text = JSON.stringify(schema);
  document.head.appendChild(script);
};

const Seo = ({
  title,
  description,
  path = '/',
  image = '/community-icon.svg',
  type = 'website',
  schema
}) => {
  useEffect(() => {
    const siteName = 'Rejection Tales';
    const url = `${window.location.origin}${path}`;
    const pageTitle = title ? `${title} | ${siteName}` : siteName;

    document.title = pageTitle;
    ensureMetaTag('name', 'description', description);
    ensureMetaTag('property', 'og:title', pageTitle);
    ensureMetaTag('property', 'og:description', description);
    ensureMetaTag('property', 'og:type', type);
    ensureMetaTag('property', 'og:url', url);
    ensureMetaTag('property', 'og:image', `${window.location.origin}${image}`);
    ensureMetaTag('name', 'twitter:card', 'summary_large_image');
    ensureMetaTag('name', 'twitter:title', pageTitle);
    ensureMetaTag('name', 'twitter:description', description);
    ensureMetaTag('name', 'twitter:image', `${window.location.origin}${image}`);
    setCanonical(url);
    setJsonLd(schema);

    return () => {
      const jsonLdScript = document.getElementById('page-json-ld');
      if (jsonLdScript) {
        jsonLdScript.remove();
      }
    };
  }, [title, description, path, image, type, schema]);

  return null;
};

export default Seo;
